import { useTranslation } from "react-i18next";
import { Button, Modal } from "antd";

interface Props {
  open: boolean;
  onClose: () => void;
  email: string;
}

export const SupportSuccessModal = ({ open, onClose, email }: Props) => {
  const { t } = useTranslation();

  return (
    <Modal
      open={open}
      title={t("support.requestSentTitle")}
      onCancel={onClose}
      footer={
        <Button type="primary" onClick={onClose}>
          {t("app.close")}
        </Button>
      }
    >
      <p>{t("support.requestSentEmail", { email })}</p>
    </Modal>
  );
};
